export default (file, MAX_FILE_SIZE) => {
  const { size } = file;
  const fileSize = size / 1024 / 1024;
  return fileSize <= MAX_FILE_SIZE;
};
